'use client';

import { InputHTMLAttributes, startTransition } from 'react';
import { useSelectedFilters } from './useSelectedFilters';
import { scrollToResults } from './scrollToResults';
import { useScrollTargetRef } from './FilterScrollTarget';

export const FilterCheckbox = ({
	optionKey,
	groupKey,
	...props
}: {
	optionKey: string;
	groupKey: string;
} & InputHTMLAttributes<HTMLInputElement>) => {
	const [selectedFilters, navigateFilters] = useSelectedFilters();
	const checked = selectedFilters.get(groupKey)?.has(optionKey) ?? false;
	const scrollTargetRef = useScrollTargetRef();

	return (
		<input
			type="checkbox"
			{...props}
			checked={checked}
			onChange={({ currentTarget }) => {
				const checked = currentTarget.checked;

				startTransition(() => {
					navigateFilters({
						groupKey,
						optionKey,
						checked,
					});
				});

				scrollToResults(scrollTargetRef?.current);
			}}
		/>
	);
};
